import {
  ClassTypeEnum,
  LdapSearchItem as LdapSearchItemGenerated,
  PripomienkaDetail as PripomienkaDetailGenerated,
  PripomienkaDetailApi,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import { generatedToTypPripomienky } from '../model/pripomienka/TypPripomienky';
import { generatedToStavPripomienky } from '../model/pripomienka/StavPripomienky';
import PripomienkaDetail from '../model/pripomienka/PripomienkaDetail';
import { generatedToPovahaPripomienky } from '../model/pripomienka/PovahaPripomienky';
import LdapSearchItem from '../model/LdapItem';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new PripomienkaDetailApi(apiConfiguration(pripomienkyPrefixPath));

const mapPripomienkaDetail = (generated: PripomienkaDetailGenerated): PripomienkaDetail => ({
  uuid: generated.uuid,
  pripomienkaK: generated.pripomienkaK,
  text: generated.textPripomienky,
  stav: generatedToStavPripomienky(generated.stav),
  typ: generatedToTypPripomienky(generated.typPripomienky),
  odoslana: generated.odoslana,
  pripomienkujuciSubjekt: mapLdapItem(generated.pripomienkujuciSubjekt),
  datumPripomienkovania: new Date(generated.datumPripomienkovania),
  pocetPodporovatelov: generated.pocetPodporovatelov,
  somPodporovatel: generated.somPodporovatel,
  povahaPripomienky: generatedToPovahaPripomienky(generated.povahaPripomienky),
  pripomienkovatel: mapLdapItem(generated.pripomienkovatel),
  priradeny: mapLdapItem(generated.priradeny),
  vyhodnotil: mapLdapItem(generated.vyhodnotil),
  textVyhodnotenia: generated.textVyhodnotenia,
  predchadzajucaPripomienkaId: generated.predchadzajucaPripomienkaId,
  nasledujucaPripomienkaId: generated.nasledujucaPripomienkaId,
});

const mapLdapItem = (generated: LdapSearchItemGenerated): LdapSearchItem => (generated ? {
  uuid: generated.uuid,
  fullName: generated.fullName,
  shortName: generated.shortName,
} : null);

// eslint-disable-next-line import/prefer-default-export
export const fetchPripomienkaDetail = async (
  classType: ClassTypeEnum,
  type: string,
  year: number,
  index: number,
  uuid: string,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<PripomienkaDetail>> => {
  const {
    data,
    status,
  } = await client.getPripomienkaDetail(classType, type, year, index, uuid, options);
  return {
    data: mapPripomienkaDetail(data),
    responseCode: status,
  };
};
